export class RefreshTokenModel {
	public accessToken: string;
	public azureToken: string;
	public refreshToken: string;

	public convert(dto: any): RefreshTokenModel {
		if (dto.accessToken) {
			this.accessToken = dto.accessToken;
		}
		if (dto.azureToken) {
			this.azureToken = dto.azureToken;
		}
		if (dto.refreshToken) {
			this.refreshToken = dto.refreshToken;
		}

		return this;
	}

	public storeRefreshTokenToLocalStorage(data: RefreshTokenModel) {
		localStorage.setItem('superAppsBack.accessToken', data.accessToken);
		localStorage.setItem('superAppsBack.azureToken', data.azureToken);
		localStorage.setItem('superAppsBack.refreshToken', data.refreshToken);
	}
}
